// extracted by mini-css-extract-plugin
export var active = "_dt-7";
export var container = "_dt-0";
export var evenWidth = "_dt-4";
export var large = "_dt-5";
export var outlet = "_dt-8";
export var slide = "_dt-2";
export var small = "_dt-6";
export var tab = "_dt-3";
export var tabs = "_dt-1";